/* loaded by smart-asset */
export default require("./logo_on_white~mPoHurDN.svg")